export async function autoAdjust(doneCallback) {
    var dataPerChannel = await getFullImagePixels.call(this);

    var grayscaleData = [];
    for (let i = 0; i < dataPerChannel.r.length; i++) {
        grayscaleData[i] = Math.floor(0.299 * dataPerChannel.r[i] + 0.587 * dataPerChannel.g[i] + 0.114 * dataPerChannel.b[i]);
    }

    const histogram = getHistogram(grayscaleData);

    const numOfPixels = dataPerChannel.r.length

    const valuesPercentage = [];
    for (let i = 0; i < histogram.length; i++) {
        valuesPercentage.push(histogram[i] / numOfPixels * 100);
    }

    const percThreshhold = 0.01;
    const start = valuesPercentage.findIndex(p => p >= percThreshhold);
    const end = histogram.findIndex(p => p === Math.max(...histogram))
    const scale = 255.0 / (end - start);

    const contrast = scale;
    const brightness = ((start * scale) - (scale * 128) + 128) * -1;
    this.setBrightness(brightness);
    this.setContrast(contrast);

    this.redraw();
    if (doneCallback && (typeof doneCallback === "function")) {
        doneCallback.call();
    }
}

async function getFullImagePixels() {
    const sessionId = this.sessionID;
    const activeLayer = this.getActiveLayer();
    const activeTimeFrame = this.getActiveTimeFrame();
    const scale = 1000.0 / Math.max(this.imageInfo.Width, this.imageInfo.Height);
    const url = `${this.serverUrls[0]}/region?pathOrUid=${encodeURIComponent(this.imageInfo.Filename)}&format=jpg&timeframe=${activeTimeFrame}&layer=${activeLayer}&sessionID=${encodeURIComponent(sessionId)}&x=0&y=0&width=${this.imageInfo.Width}&height=${this.imageInfo.Height}&scale=${scale}`;
    const image = await loadImage(url);

    const pixels = getImageData(image);
    const pixelsPerChannel = getChannels(pixels);
    return pixelsPerChannel;
}

const loadImage = (imageUrl) => {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.crossOrigin = 'Anonymous';
        img.src = imageUrl;
    });
};

const getImageData = (img) => {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const context = canvas.getContext('2d');
    context.drawImage(img, 0, 0);
    const { data } = context.getImageData(0, 0, img.width, img.height);
    return data;
};

const getChannels = (data) => {
    const r = [];
    const g = [];
    const b = [];
    const a = [];
    for (let i = 0; i < data.length;) {
        r.push(data[i++]);
        g.push(data[i++]);
        b.push(data[i++]);
        a.push(data[i++]);
    }

    return {
        r, g, b, a,
    };
};

const getHistogram = (channel, L = 256) => {
    const result = new Array(L).fill(0);
    for (const value of channel) {
        result[value]++;
    }

    return result;
};

const getCdf = (channel, L = 256) => {
    const histogram = getHistogram(channel);
    const histogramSum = histogram.reduce((acc, el) => acc + el, 0);
    const pxi = i => 1.0 * histogram[i] / histogramSum;

    const cdf = new Array(L);
    let lastCdfValue = 0;
    for (let i = 0; i < L; i++) {
        cdf[i] = lastCdfValue + pxi(i);
        lastCdfValue = cdf[i];
    }

    return cdf;
};

export function brightnessContrastFilter(pixels, brightness, contrast, gamma) {
    var lookupTable = [];
    if (!gamma || gamma < 0) {
        gamma = 0;
    }

    for (var i = 0; i < 256; i++) {
        var value = contrast * (i - 128) + 128 + brightness;
        if (gamma != 1) {
            value = 255 * Math.pow(value / 255, 1 / gamma);
        }

        if (value[i] < 0) {
            value[i] = 0;
        }

        if (value[i] > 255) {
            value[i] = 255;
        }

        lookupTable.push(value);
    }

    for (i = 0; i < pixels.length; i += 4) {
        pixels[i] = lookupTable[pixels[i]];
        pixels[i + 1] = lookupTable[pixels[i + 1]];
        pixels[i + 2] = lookupTable[pixels[i + 2]];
        //pixels[i + 3] = 0;
    }
}

export function colorBalanceFilter(pixels, red, green, blue) {
    for (let i = 0; i < pixels.length; i += 4) {
        pixels[i] = Math.max(0, Math.min(255, pixels[i] * red));
        pixels[i + 1] = Math.max(0, Math.min(255, pixels[i + 1] * green));
        pixels[i + 2] = Math.max(0, Math.min(255, pixels[i + 2] * blue));
        //pixels[i + 3] = 0;
    }
}

